import { useSrpContext } from '@/src/contexts'
import { Box, Container, Divider, Link as MuiLink, Typography } from '@mui/material'
import { useLocale, useTranslations } from 'next-intl'
import Link from 'next/link'

export default function Links () {
    const {
        SEOSrpData: { pageData }
    } = useSrpContext()
    const { topRoutes, topAirlines, topDestinations } = pageData || {}
    const locale = useLocale()
    const t = useTranslations('homePage.headings')
    const sectionHeadingIds = {
        topDestinations: 'flight-schedule-links-top-destinations-heading',
        topRoutes: 'flight-schedule-links-top-routes-heading',
        topAirlines: 'flight-schedule-links-top-airlines-heading'
    } as const
    const sectionStyle = {
        py: 3,
        height: 'fit-content'
    }

    const headingStyle = {
        fontSize: { xs: '1.125rem', md: '1.25rem' },
        fontWeight: 600,
        color: '#333333',
        mb: 2.5
    }

    const listStyle = {
        display: 'flex',
        flexWrap: 'wrap',
        columnGap: 2,
        rowGap: 1,
        m: 0,
        p: 0,
        listStyle: 'none'
    }

    const linkStyle = {
        color: '#4d6f93',
        textDecoration: 'none',
        fontSize: '14px',
        lineHeight: 1.5,
        display: 'inline-block',
        '&:hover': {
            textDecoration: 'underline'
        },
        '&:focus-visible': {
            textDecoration: 'underline'
        }
        // '&:hover': {
        //     textDecoration: 'underline',
        //     color: '#357abd'
        // },
        // '&:visited': {
        //     color: '#4a90e2'
        // }
    }

    return (
        <Box component="section" aria-label="Popular flight schedule links" bgcolor={'#f8f9fa'}>
            <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, lg: 4 }, py: 1 }}>
                {/* Top Destinations Section */}
                <Box component="nav" aria-labelledby={sectionHeadingIds.topDestinations} sx={sectionStyle}>
                    <Typography id={sectionHeadingIds.topDestinations} component="h2" variant="h3" sx={headingStyle}>
                        {t('topDestinations')}
                    </Typography>
                    <Box component="ul" sx={listStyle}>
                        {topDestinations?.map((destination, index) => (
                            <Box component="li" key={index}>
                                <Link href={destination.href} passHref legacyBehavior>
                                    <MuiLink target="_parent" data-tracker="TOP_DESTINATIONS" sx={linkStyle}>
                                        {destination.name}
                                    </MuiLink>
                                </Link>
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Divider />

                {/* Top Routes Section */}
                <Box component="nav" aria-labelledby={sectionHeadingIds.topRoutes} sx={sectionStyle}>
                    <Typography id={sectionHeadingIds.topRoutes} component="h2" variant="h3" sx={headingStyle}>
                        {t('topRoutes')}
                    </Typography>
                    <Box component="ul" sx={listStyle}>
                        {topRoutes?.map((route, index) => (
                            <Box component="li" key={index}>
                                <Link href={`/${locale}${route.href}`} passHref legacyBehavior>
                                    <MuiLink target="_parent" data-tracker="TOP_ROUTES" sx={linkStyle}>
                                        {route.name}
                                    </MuiLink>
                                </Link>
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Divider />

                {/* Top Airlines Section */}
                <Box component="nav" aria-labelledby={sectionHeadingIds.topAirlines} sx={sectionStyle}>
                    <Typography id={sectionHeadingIds.topAirlines} component="h2" variant="h3" sx={headingStyle}>
                        {t('topAirlines')}
                    </Typography>
                    <Box component="ul" sx={listStyle}>
                        {topAirlines?.map((airline, index) => (
                            <Box component="li" key={index}>
                                <Link href={airline.href} passHref legacyBehavior>
                                    <MuiLink target="_parent" data-tracker="TOP_AIRLINES" sx={linkStyle}>
                                        {airline.name}
                                    </MuiLink>
                                </Link>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}
